module.exports = __webpack_public_path__ + "static/media/instagram.a0d02930.png";